import React from 'react';
import SelectInput from '../Inputs/SelectInput';

import { Controller } from 'react-hook-form';

const ControlledSelectInput = props => {
  const { name, control, options, onChange: handleOnChange, ...rest } = props;

  return (
    <Controller
      name={name}
      control={control}
      render={({ onChange, ref, value }) => {
        return (
          <SelectInput
            {...rest}
            value={value}
            // if defaultValue on input is undefined, react treats the component as uncontrolled and throws a warning
            inputProps={{ ...rest.inputProps, defaultValue: '' }}
            options={options}
            inputRef={ref}
            onChange={selected => {
              if (handleOnChange) {
                handleOnChange(selected.target.value);
              }

              onChange(selected);
            }}
          />
        );
      }}
    />
  );
};

export default ControlledSelectInput;
